'use client';
import { SpeedInsights } from '@vercel/speed-insights/next';

export const FilteredSpeedInsights = () => (
  <SpeedInsights
    beforeSend={(data) => {
      // Ignore dashboard insights
      if (data.url.includes('/usage')) return null;

      return data;
    }}
  />
);
